import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import DocsCoursesEvent from '@modules/eventStream/enum/DocsCoursesEvent';
import useCurrentLocale from '@modules/localization/hooks/useCurrentLocale';

interface ResetProgressDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ResetProgressDialog: React.FC<ResetProgressDialogProps> = ({ open, onConfirm, onCancel }) => {
  const { translate } = useTranslation();
  const { targetLocale } = useCurrentLocale();

  useEffect(() => {
    if (open) {
      unifiedLoggerClient.logImpressionEvent({
        eventName: DocsCoursesEvent.openResetProgressDialog,
        parameters: {
          locale: targetLocale ? String(targetLocale) : '',
        },
      });
    }
  }, [open, targetLocale]);

  const handleConfirm = () => {
    unifiedLoggerClient.logClickEvent({
      eventName: DocsCoursesEvent.clickResetProgress,
      parameters: {
        locale: targetLocale ? String(targetLocale) : '',
      },
    });
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          width: '444px',
          height: '194px',
        },
      }}>
      <DialogTitle variant='h4'>{translate('Label.ResetCourseProgress')}</DialogTitle>
      <DialogContent>
        <Typography color='secondary' variant='body2'>
          {translate('Message.ResetProgressDialog')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} variant='contained' color='primaryBrand'>
          {translate('Action.Ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetProgressDialog;
